/* eslint-disable no-param-reassign */
/* eslint-disable no-script-url */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable consistent-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-unused-class-component-methods */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'utilities/withRouterWrapper';
import { Button, Modal, Label, ModalHeader, ModalBody } from 'reactstrap';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import FileSaver from 'file-saver';
import { formatNowShiftedByUtcOffset } from 'utilities/date';
import UploadFiles from 'api/UploadFiles';
import PreviewAllAttachments from 'common/PreviewAllAttachments';
import PdfViewer from 'components/PdfViewer/PdfViewer';
import { MIXPANEL_INVOICE_PAID_EVENT } from 'constants/constants';
import * as actions from 'actions/TaskActions';
import DetailBottom from 'components/Tasks/Edit/DetailBottom';
import { AttachementPortion } from 'common/CustomFields';
import PageNotFound from 'common/PageNotFound';
import { AlertMessage, getFirmType } from 'utilities/utils';
import * as NotificationActions from 'actions/NotificationActions';
import * as paginationActions from 'actions/PaginationActions';
import TaskPdfLayout from 'components/Tasks/Edit/TaskPdfLayout';
import liscioSmallest from 'images/lisciosmallest.png';
import { trackMixpanelEvent } from 'Mixpanel/mixpanelfn';
import { recurringFrequencyStr } from 'components/Billing/billingUtils';
import InvoiceDetailsTop from './InvoiceDetailsTop';

const noneStyle = { display: 'none' };
const blockStyle = { display: 'block' };
const isIE = /* @cc_on!@ */ false || !!document.documentMode;

class InvoiceTaskDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      load: false,
      documents: [],
      comments: [],
      commentsActivity: [],
      commentsHistory: [],
      taskStatus: '',
      activeArray: 'commentsActivity',
      activeTab: 0,
      showAttachmentModal: false,
      selectedAttachment: '',
      noTask: false,
      taskLoadFailed: false,
      // AttachementPortion opens attachments in the in-page preview only when set.
      previewPopUp: true,
      previewScreen: false,
      previewDocument: null,
    };
    this.toggle = this.toggle.bind(this);
    this.changeActiveTab = this.changeActiveTab.bind(this);
    this.fetchtaskDetail = this.fetchtaskDetail.bind(this);
    this.openAttachment = this.openAttachment.bind(this);
  }

  componentDidMount() {
    document.title = 'Billing';
    if (getFirmType() === 'liscio-lite') {
      this.props.navigate('/');
    }
    this.fetchtaskDetail(true);
    this.props.actions.receivedNotification(false);
    // action cable for task detail channel
    // const cookies = new Cookies();
    this.showSuccessMessage();
  }

  // re-render component whenever the url changes
  componentDidUpdate(prevProps) {
    document.title = `Billing - ${this.props.taskDetail.subject}`;
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.fetchtaskDetail(true);
    }

    if (
      this.props.taskDetail &&
      this.props.taskDetail.invoice_amount &&
      this.state.invoicePaid
    ) {
      this.trackInvoicePaidEvent(this.props);
      this.setState({ invoicePaid: false });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      ['bill', 'invoice'].includes(nextProps.taskDetail.task_type_key) &&
      nextProps.taskDetail.id !== this.props.taskDetail.id
    ) {
      this.setState({ paymentStatus: nextProps.taskDetail.payment_status });
    }
  }

  componentWillUnmount() {
    if (this.TaskCable && this.myTaskSubscription) {
      this.TaskCable.subscriptions.remove(this.myTaskSubscription);
    }
    this.props.actions.fetchDetail({});
  }

  showSuccessMessage = () => {
    const currentUrl = new URL(window.location.href);
    const isSuccess = currentUrl.searchParams.get('success');
    const sessionId = currentUrl.searchParams.get('session_id');
    if (isSuccess && !sessionId) {
      AlertMessage('success', 'Invoice Paid Successfully');
      this.setState({ invoicePaid: true });
    }
  };

  trackInvoicePaidEvent = (props) => {
    const { invoice_amount, is_recurring, frequency, recurring_interval } =
      props.taskDetail;
    trackMixpanelEvent(MIXPANEL_INVOICE_PAID_EVENT, {
      amount: invoice_amount / 100,
      type: is_recurring ? 'recurring' : 'onetime',
      frequency,
      recurring_interval,
    });
  };

  handleGoBack = () => {
    const { location, navigate } = this.props;
    const requestedGoBackUrl = location?.state?.goBackUrl;
    const isRetiredManagementPath =
      typeof requestedGoBackUrl === 'string' &&
      (/^\/billing\/(invoices|recurring)(\/|$)/.test(requestedGoBackUrl) ||
        /^\/accountdetails\/[^/]+\/billing\/(invoices|recurring)(\/|$)/.test(
          requestedGoBackUrl
        ));
    const canReturnToLocalPage =
      typeof requestedGoBackUrl === 'string' &&
      requestedGoBackUrl.startsWith('/') &&
      !requestedGoBackUrl.startsWith('//') &&
      !isRetiredManagementPath;

    if (canReturnToLocalPage) {
      navigate(requestedGoBackUrl);
      return;
    }

    // React Router keys the first entry of a session 'default'. Any other key
    // means an in-app page precedes this one, so Back can return to it. A
    // payment-success redirect or a retired management URL goes home instead.
    const isPaymentReturn = new URLSearchParams(
      location?.search || window.location.search
    ).has('success');
    const hasInAppHistory =
      Boolean(location?.key) && location.key !== 'default';
    if (hasInAppHistory && !isPaymentReturn && !isRetiredManagementPath) {
      navigate(-1);
      return;
    }

    navigate('/');
  };

  fetchtaskDetail = (loading) => {
    const url = window.location.pathname.split('/');
    if (url) {
      const id = url[url.length - 1];
      const { state } = this.props.location;
      this.props.actions.fetchtaskDetail(id, this, loading, '', state);
    }
  };

  updateTaskDetail = (data) => {
    this.setState({
      documents: data.documents,
      comments: data.comments,
      commentsActivity: data.my_activity,
      commentsHistory: data.history,
      taskStatus: data.status,
    });
    this.props.actions.fetchDetail(data);
  };

  changeActiveTab = (tabIndex, each) => {
    this.setState({
      activeTab: tabIndex,
      filter: each.value,
      [each.array]: this.props.taskDetail[each.value] || [],
      activeArray: each.array,
    });
  };

  downloadAttachments = () => {
    const url = this.state.documents;
    const zip = new JSZip();
    let count = 0;
    url.map((item) => {
      const urlPath = item.aws_url_origional;
      // const fileName = item.file_name;.
      let fileName = item.file_name;
      if (fileName.split('.').length === 1) {
        fileName = `${item.file_name}.${item.content_type.split('/')[1]}`;
      }
      JSZipUtils.getBinaryContent(urlPath, (err, data) => {
        if (err) {
          throw err;
        }
        const convertTime = formatNowShiftedByUtcOffset();
        zip.file(fileName, data, {
          binary: true,
          createFolders: false,
          date: new Date(convertTime),
        });
        count += 1;
        if (count === url.length) {
          zip.generateAsync({ type: 'blob' }).then((content) => {
            FileSaver.saveAs(content, 'all_docs.zip');
          });
        }
      });
      return true;
    });
  };

  toggle = () => {
    const { navigate, location } = this.props;
    const { taskStatus } = this.state;
    if (location.state?.from) {
      if (
        location.state.from &&
        (location.state.from === 'uploadlist' ||
          location.state.from === 'notify' ||
          location.state.from === 'edocpreview')
      ) {
        navigate(-1);
      } else {
        navigate(location.state.from, {
          isBack: true,
          state: { Status: taskStatus },
        });
      }
    } else {
      this.fetchtaskDetail(true);
    }
  };

  openAttachment = async (c, isLink) => {
    await UploadFiles.showOpenAttachment(c, this, isLink);
  };

  previewOpenAttachment = (doc, isLink) => {
    if (isLink) {
      doc = JSON.parse(decodeURIComponent(doc));
    }
    this.setState({ previewScreen: true, previewDocument: doc });
  };

  previewCloseAttachment = (data) => {
    const { documents } = this.state;
    if (data?.editedFileName) {
      documents.map((doc) => {
        if (doc.id === data?.selectedItem.id && data?.editedFileName) {
          doc.doc_name = data.editedFileName;
        }
        return doc;
      });
      this.fetchtaskDetail(true);
    }
    this.setState({
      previewScreen: false,
      previewDocument: null,
      documents,
    });
  };

  attachmentModalClose = () => {
    this.setState({ showAttachmentModal: false, selectedAttachment: '' });
  };

  handleForceUpdate = () => {
    this.fetchtaskDetail(true);
    this.props.actions.receivedNotification(false);
  };

  handlePrintPdf = () => {
    this.setState({ renderPdfLayout: !this.state.renderPdfLayout });
  };

  render() {
    const { match, taskDetail } = this.props;
    const keys = Object.keys(taskDetail);
    const {
      subject,
      task_type_color,
      task_type_value,
      is_recurring,
      invoice_status,
      recurring_interval,
    } = taskDetail;

    const {
      noTask,
      taskLoadFailed,
      renderPdfLayout,
      documents,
      previewDocument,
    } = this.state;

    if (noTask) {
      return <PageNotFound name="message" message="(No Such Task Found)" />;
    }
    if (taskLoadFailed) {
      return <PageNotFound name="message" message="(Unable to Load Task)" />;
    }
    let activeDocuments = [];
    if (documents?.length > 0) {
      activeDocuments = documents.filter((item) => item.is_active);
    }
    if (keys.length && !noTask && !this.state.loading) {
      return (
        <div
          id="content"
          style={{ position: 'relative' }}
          className="InvoiceTaskDetail__Container"
        >
          <div className="center-wrapper">
            {/* will show loading icom when user clicks om archive or close task */}
            {this.state.load ? (
              <div id="loading" role="status" aria-label="Loading invoice" />
            ) : null}
            <div className="mb-3 pb-3 section-title section-title--bottomborder">
              <div className="col-container">
                <div className="col infoHeader">
                  <h6 role="presentation" className="stepBacklink">
                    <a onClick={this.handleGoBack} href="javascript:;">
                      <i className="icon-left-arrow" /> Back
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="taskWrap">
              <div className="taskWrap--inner mb-5">
                <div className="contentHasicon mt-4 mb-4">
                  <div className="contentHasicon--inner clrGreen align-self-center">
                    <i
                      className="iconCircle iconCircle--green icon-tickmark_trans_o"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="taskWrap--header flex-grow-1">
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <span className={`badge ${task_type_color}`}>
                          {task_type_value}
                        </span>
                        <h2 className="mainHeading mb-0">{subject}</h2>
                      </div>
                      <div className="col-md-6 col-sm-12 align-self-center text-right ">
                        <div className="row">
                          <div className="col" />
                          <div>
                            <div className="date text-small mb-1">
                              {is_recurring ? (
                                <span className="text-body">
                                  <i className="icon-Recurring pr-1 vertical-middle text-primary" />
                                  Recurs{' '}
                                  {recurringFrequencyStr(recurring_interval)}
                                </span>
                              ) : null}
                            </div>
                            <div className="task-status ml-auto align-self-end">
                              <Label
                                htmlFor="status"
                                className="label-medium font-normal mb-0 mr-2 text-uppercase text-dark"
                              >
                                Status :
                              </Label>
                              <span className="tag tag--fill">
                                {invoice_status}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <InvoiceDetailsTop
                  data={taskDetail}
                  className="InvoiceTaskDetail"
                />
                <div className="formsetValue">
                  <div className="form-group form-inline-label mb-md-5">
                    <label
                      htmlFor="backdrop"
                      className="align-self-start mt-3 pt-1"
                    >
                      Attachments:
                    </label>
                    <div className="labelValue w-100">
                      <div className="dragWrap col-8 p-0">
                        <AttachementPortion
                          name="taskDetail"
                          readOnly
                          data={this.state}
                          documents={this.state.documents}
                          openAttachment={this.openAttachment}
                          component={this}
                          dataProps={taskDetail}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.taskStatus !== 'Draft' && (
                  <DetailBottom
                    toggle={this.toggle}
                    data={this.state}
                    changeActiveTab={this.changeActiveTab}
                    fetchtaskDetail={this.fetchtaskDetail}
                    updateTaskDetail={this.updateTaskDetail}
                    onDocumentClick={this.previewOpenAttachment}
                    taskId={taskDetail.id}
                    props={this.props}
                    isInvoiceTask
                    readOnly
                  />
                )}
              </div>
              {match.pathname.includes('/task/detail') &&
                this.props.notificationAvailable && (
                  <div className="chat-Message">
                    <div className="Chat-Txt">
                      <img
                        src={liscioSmallest}
                        alt="Avatar"
                        className="avatar chat-Img"
                      />
                      <h2>Task Detail Updated</h2>
                    </div>
                    <div className="Chat-show">
                      <Button
                        onClick={this.handleForceUpdate}
                        className="btn-link btn--onlyicon btn btn-secondary cross-btn"
                      >
                        Show
                      </Button>
                      <span
                        onClick={() => {
                          this.props.actions.receivedNotification(false);
                        }}
                      >
                        <i className="icon-close2" aria-hidden="true" />
                      </span>
                    </div>
                  </div>
                )}
            </div>
            <Modal
              isOpen={this.state.showAttachmentModal}
              className="customModal customModal--w990 customModal--nopadding modalMxHeight"
            >
              <ModalHeader className="ModalHeader">
                <button
                  type="button"
                  onClick={() => this.attachmentModalClose()}
                  className="close"
                  aria-label="Close"
                >
                  <i className="icon-close2" aria-hidden="true" />
                </button>
              </ModalHeader>
              <ModalBody className="modalContent">
                <div className="modalContent--inner">
                  <div
                    className={
                      isIE ? 'left-inner-content' : 'sample-letter-preview'
                    }
                  >
                    <div className="letter-logo" />
                    {isIE ? (
                      <PdfViewer file={this.state.selectedAttachment} />
                    ) : (
                      <iframe
                        width="100%"
                        height="600"
                        name="myfilename"
                        src={this.state.selectedAttachment}
                        title="selected attachment"
                      />
                    )}
                  </div>
                </div>
              </ModalBody>
            </Modal>
          </div>
          {this.state.previewScreen && (
            <Modal
              className="Md-full-width modal-FullH"
              isOpen={this.state.previewScreen}
            >
              <PreviewAllAttachments
                uploadType="task"
                fro="taskDetail"
                docs={activeDocuments}
                taskDetail={this.props.taskDetail}
                selectedDocument={previewDocument}
                closePreview={this.previewCloseAttachment}
                readOnly
              />
            </Modal>
          )}
          {renderPdfLayout ? (
            <TaskPdfLayout
              data={{ ...this.state, ...taskDetail }}
              handlePrintPdf={this.handlePrintPdf}
            />
          ) : null}
        </div>
      );
    }

    return (
      <div
        id="loading"
        style={this.state.loading ? blockStyle : noneStyle}
        role="status"
        aria-label="Loading invoice"
      />
    );
  }
}

const mapStateToProps = (state) => ({
  taskDetail: state.taskReducer.taskDetail,
  notificationAvailable: state.taskReducer.notificationAvailable,
  tasks: state.taskReducer.tasks,
  taskStatus: state.taskReducer.taskStatus,
  task_page: state.paginationReducer.task_page,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  NotificationActions: bindActionCreators(NotificationActions, dispatch),
  pagination: bindActionCreators(paginationActions, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InvoiceTaskDetails)
);
